import React from 'react';
//import PropTypes from 'prop-types';
import { DropTarget } from 'react-dnd';
import {isEmpty} from 'lodash';
import { connect } from '../../utils';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import FontIcon from 'material-ui/FontIcon';

const defaultBorder ={
  type: "solid",
  size: 0,
  color: "#e61919"
}


const target = {
  drop(props, monitor, component) {
    if (!monitor.didDrop()) {
      props.layoutState.insertOrMoveItem(props.id, props.children.length, monitor.getItem());
    }
  }
};
const EditLayout = ({ id, children, isOverCurrent, connectDropTarget, type, layoutState, readOnly }) => {
  const {values} = layoutState.getItemJS(id).props;
  const isBorder = values.border ? `${values.border.size}px ${values.border.type} ${values.border.color}` : `${defaultBorder.size}px ${defaultBorder.type} ${defaultBorder.color}`;  
  const childIcon = !isEmpty(values.icon) ? (<FontIcon className="material-icons"> {values.icon} </FontIcon>): null;
  const childButton = (values.typeButton === 'raised') ? (<RaisedButton 
    label={values.text} 
    fullWidth={values.fullWidth}
    labelPosition={values.labelPosition} 
    icon={childIcon}
    labelColor={values.buttonColors.color}
    backgroundColor={values.buttonColors.backgroundColor} 
    labelStyle={{ textTransform: "none", border: isBorder}}
    style={{height: "auto", lineHeight: "200%"}}
  />) : (<FlatButton 
    label={values.text} 
    fullWidth={values.fullWidth}
    labelPosition={values.labelPosition} 
    icon={childIcon}
    hoverColor={values.buttonColors.hoverColor} 
    backgroundColor={values.buttonColors.backgroundColor} 
    rippleColor={values.buttonColors.rippleColor} 
    style={{color: values.buttonColors.color, height: "auto", lineHeight: "200%",border: isBorder}}
    labelStyle={{ textTransform: "none"}}
  />);
  return connectDropTarget(
    <div style={{
      boxSizing: 'border-box',
      position: 'relative',
      height: 'auto',
      display: 'flex',
      width:'100%',
      justifyContent: values.buttonAlign,
      flex:1,
      padding: values.containerPadding
    }}>
      {childButton}
    </div>
  );
};
/**
 * note : in here for edit not show the target url for button
 * href={values.href.url}
   target={values.href.target}
 */
const LayoutContainer = DropTarget('FlatButtonView', target, (conn, monitor) => ({
  connectDropTarget: conn.dropTarget(),
  isOverCurrent: monitor.isOver({shallow: true})
}))(EditLayout);

export default connect('layoutState', 'readOnly')(LayoutContainer);



// WEBPACK FOOTER //
// ./src/editor/layout/components/Layout/DnDFlatButton.js